export const scrollOffsetForTarget = (target, fallback = 73) => {
  const scrollMarginTop = Number.parseFloat(
    window.getComputedStyle(target).scrollMarginTop
  );

  const rootOffset = Number.parseFloat(
    window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--cb-nav-offset")
  );

  return Number.isFinite(scrollMarginTop) && scrollMarginTop > 0
    ? scrollMarginTop
    : Number.isFinite(rootOffset) && rootOffset > 0
      ? rootOffset
      : fallback;
};
